import { render, staticRenderFns } from "./ModalErro.vue?vue&type=template&id=7bed71f6"
import script from "./ModalErro.vue?vue&type=script&lang=js"
export * from "./ModalErro.vue?vue&type=script&lang=js"
import style0 from "./ModalErro.vue?vue&type=style&index=0&id=7bed71f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports